import {
  detectRedFlags,
  haltingCodes,
  haltsTraining,
  hasUrgentFlag,
  type RedFlag,
  type RedFlagCheckin,
} from '@cadencia/domain';
import { getRecentCheckins } from '../repositories/readinessRepo.js';
import { todayLocal } from '../../lib/dates.js';

/**
 * Banderas rojas vigentes, a partir de los check-ins recientes.
 *
 * Vive en la capa de datos porque necesita leer; la decision es del dominio, que
 * es puro. La app pregunta antes de prescribir, no despues.
 */
export async function currentRedFlags(userId: string, today = todayLocal()): Promise<RedFlag[]> {
  const checkins = await getRecentCheckins(userId, 14);

  const entrada: RedFlagCheckin[] = checkins.map((checkin) => ({
    forDate: checkin.forDate,
    sleepHours: checkin.sleepHours,
    reportedSymptoms: checkin.reportedSymptoms,
    sorenessAreas: checkin.sorenessAreas,
  }));

  // `today` en local: un síntoma solo vale el día que se marca (23/09/2026).
  return detectRedFlags({ recentCheckins: entrada, today });
}

export interface SafetyState {
  flags: RedFlag[];
  /** true si no se puede prescribir NADA hasta que se resuelva. */
  trainingHalted: boolean;
  /**
   * Posible urgencia: no hay sesión que ofrecer, ni siquiera sin cargas. La
   * pantalla enseña solo qué hacer.
   */
  urgent: boolean;
  codes: string[];
}

export async function currentSafetyState(userId: string): Promise<SafetyState> {
  const flags = await currentRedFlags(userId);
  return {
    flags,
    trainingHalted: haltsTraining(flags),
    urgent: hasUrgentFlag(flags),
    codes: haltingCodes(flags),
  };
}
